import { quickStats } from "@/mocks/home";

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden pt-[104px] md:pt-[112px]">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20dark%20cinematic%20background%20of%20floating%20translucent%20glass%20document%20panels%20and%20soft%20glowing%20data%20streams%20over%20deep%20charcoal%20surface%2C%20warm%20vermilion%20and%20amber%20light%20accents%2C%20elegant%20minimal%20composition%2C%20subtle%20film%20grain%2C%20moody%20atmosphere%2C%20no%20text%2C%20no%20people&width=1920&height=1080&seq=secretary-hero-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/55 to-black/75"></div>
      </div>

      <div className="relative mx-auto w-full max-w-6xl px-4 md:px-6 py-14 md:py-24 flex items-center md:min-h-[80vh]">
        <div className="animate-float-up max-w-3xl">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/10 border border-background-50/25 text-accent-200 text-xs md:text-sm">
            <i className="ri-cursor-line"></i>
            网盘 · 迅雷 · 磁力 · 种子 · 阿里云盘
          </span>

          <h1 className="mt-5 font-heading text-3xl md:text-5xl font-black leading-snug text-background-50">
            善良的女秘书
            <span className="block mt-2 text-xl md:text-3xl font-bold text-accent-300">
              资源渠道查询与使用导航
            </span>
          </h1>

          <p className="mt-5 text-sm md:text-base leading-relaxed text-background-50/85 max-w-2xl">
            本站围绕「善良的女秘书」这一关键词，整理从<strong className="font-semibold text-background-50">百度云</strong>与
            <strong className="font-semibold text-background-50">网盘资源</strong>，到
            <strong className="font-semibold text-background-50">迅雷下载</strong>、
            <strong className="font-semibold text-background-50">磁力链接</strong>、
            <strong className="font-semibold text-background-50">种子资源</strong>与
            <strong className="font-semibold text-background-50">阿里云盘</strong>的查询思路与注意事项。
            本页只做渠道科普与检索指引，不托管、不提供任何受版权保护的作品文件，请通过合法渠道获取内容。
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <a
              href="#channels"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-compass-3-line text-base"></i>
              浏览六大资源渠道
            </a>
            <a
              href="#query"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-background-50/10 border border-background-50/30 text-background-50 text-sm font-semibold hover:bg-background-50/20 transition-colors whitespace-nowrap"
            >
              <i className="ri-route-line text-base"></i>
              查看四步查询流程
            </a>
          </div>

          <dl className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-px rounded-lg overflow-hidden border border-background-50/15 bg-background-50/10">
            {quickStats.map((stat) => (
              <div key={stat.label} className="px-5 py-4 bg-black/20">
                <dt className="font-heading text-2xl md:text-3xl font-bold text-accent-300">{stat.value}</dt>
                <dd className="mt-1 text-xs md:text-sm text-background-50/80">{stat.label}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}